module.exports = __webpack_public_path__ + "static/img/partner_XXII.8c451c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XXII.png
// module id = Acfg
// module chunks = 9